import { GlobalLoadingProvider } from "@/providers/global-loading-provider";
import { PosthogProvider } from "@/providers/posthog-provider";
import { routeTree } from "@/routeTree.gen";
import { ToastService } from "@/services/toast-service";
import { createRouter, Navigate, RouterProvider } from "@tanstack/react-router";
import { createRoot } from "react-dom/client";
import "./style.css";

const router = createRouter({
    routeTree,
    defaultNotFoundComponent: () => <Navigate to="/overview" />,
});

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

const App = () => (
    <GlobalLoadingProvider>
        <PosthogProvider>
            <ToastService.Provider />
            <RouterProvider router={router} />
        </PosthogProvider>
    </GlobalLoadingProvider>
);

createRoot(document.getElementById("app")!).render(<App />);
